/**
 * glossary.ts (US-17-GR-30)
 *
 * Single source of truth for abbreviation → expansion used by <AbbrLabel>.
 * Add an entry here whenever a new abbreviated metric label ships anywhere
 * in the admin console — see AbbrLabel.tsx.
 */

export interface GlossaryEntry {
  /** Full expansion shown as the native title tooltip. */
  expansion: string;
  /** Optional qualifier appended in parentheses, e.g. "(estimated)". */
  note?: string;
}

export const GLOSSARY: Record<string, GlossaryEntry> = {
  CAC: { expansion: 'Customer Acquisition Cost' },
  LTV: { expansion: 'Lifetime Value' },
  NPS: { expansion: 'Net Promoter Score' },
  MRR: { expansion: 'Monthly Recurring Revenue', note: 'estimated' },
  ARR: { expansion: 'Annual Recurring Revenue' },
  ARPU: { expansion: 'Average Revenue Per User' },
  WAU: { expansion: 'Weekly Active Users' },
  DAU: { expansion: 'Daily Active Users' },
  MAU: { expansion: 'Monthly Active Users' },
  DLQ: { expansion: 'Dead-Letter Queue' },
  AI: { expansion: 'Artificial Intelligence' },
  USD: { expansion: 'United States Dollar' },
  'Est. USD': { expansion: 'Estimated cost in US dollars' },
  KPI: { expansion: 'Key Performance Indicator' },
  E2E: { expansion: 'End-to-End' },
  SLA: { expansion: 'Service Level Agreement' },
  IBA: { expansion: 'Independent Business Agent' },
};

export type GlossaryKey = keyof typeof GLOSSARY;
